import React, { useState, useContext, useRef } from 'react';
import useIsMobile from 'utils/hooks/useIsMobile';
import { PageContext } from 'context';
import clsx from 'clsx';

import ArticleList from './ArticleList';
import OpinionListWithSelect from './OpinionListWithSelect';
import FilterBarWrapper from '../FilterBarWrapper';

import useScrollToComponent from '../../hooks/useScrollToComponent';
import useStickyHeader from '../../hooks/useStickyHeader';

const ArticleContent = () => {
  const [selected, setSelected] = useState('opinion');

  const filterBarRef = useRef(null);

  const { showHeader } = useContext(PageContext);
  const isMobile = useIsMobile();
  const isSticky = useStickyHeader(filterBarRef);
  const scrollToFilterBar = useScrollToComponent(filterBarRef);

  const filterList = [
    {
      title: 'Opinions',
      value: 'opinion',
    },
    {
      title: 'Blog',
      value: 'article',
    },
  ];

  let content;
  switch (selected) {
    case 'opinion':
      content = <OpinionListWithSelect />;
      break;
    case 'article':
      content = <ArticleList />;
      break;
    default:
      content = null;
  }

  return (
    <>
      <div ref={filterBarRef} />
      <div className="flex flex-col gap-1 w-full">
        <FilterBarWrapper
          isSticky={isSticky}
          withHeader={isSticky && showHeader}
        >
          <div className="flex gap-5">
            {filterList.map(filter => {
              const isSelected = filter.value === selected;
              return (
                <span
                  key={filter.title}
                  className={clsx(
                    'text-sm font-bold cursor-pointer',
                    isSelected ? 'text-blue-500' : 'text-neutral-500',
                  )}
                  onClick={() => {
                    setSelected(filter.value);
                    if (isMobile) {
                      scrollToFilterBar();
                    }
                  }}
                  data-testid={`${filter.value}-filter-button`}
                >
                  {filter.title}
                </span>
              );
            })}
          </div>
        </FilterBarWrapper>
        {content}
      </div>
    </>
  );
};

export default ArticleContent;
